module.exports = __webpack_public_path__ + "../front/img/568_4skuffer+hylder.94803d79.svg";